module.exports = __webpack_public_path__ + "img/A5-6-plan.cabbacfa.png";